import React, { useState } from 'react';
import * as rsuite from 'rsuite';
import { Form, Input, InputGroup, Button, Loader, Schema } from 'rsuite';
import useToaster from 'rsuite/useToaster';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { FiUser, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import * as General from '../General/General';

const { StringType } = Schema.Types;

const model = Schema.Model({
    username: StringType().isRequired('نام کاربری الزامی است'),
    password: StringType().isRequired('رمز عبور الزامی است'),
});

const Login = () => {
    const [formValue, setFormValue] = useState({ username: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [ErrorMsg, setErrorMsg] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const toaster = useToaster();

    const handleSubmit = async (valid) => {
        if (!valid) {
            return;
        }

        setLoading(true);
        setErrorMsg('');
        var RequestOption = {
            url: General.ApiRoot() + '/login/loginIntoAccount',
            method: "post",
            data: {
                "username": formValue.username,
                "password": formValue.password,
            }

        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    General.setAuth(result.data.token, result.data.user);
                    navigate('/Dashboard');
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                }).finally(() => setLoading(false))
        );
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-5 bg-[linear-gradient(135deg,theme(colors.brand.DEFAULT)_0%,theme(colors.brand.dark)_100%)]">
            <div className="w-full max-w-[380px] bg-white rounded-2xl shadow-2xl px-8 pt-10 pb-8 flex flex-col items-center text-center">
                <img
                    src={`${process.env.PUBLIC_URL}/ARM.png`}
                    alt="عرشه گستر"
                    className="w-16 h-16 object-contain mb-4"
                />
                <h1 className="text-xl font-bold text-gray-800 m-0">ورود به پنل مدیریت</h1>
                <p className="text-sm text-gray-400 mt-1.5 mb-6">عرشه گستر شیراز</p>

                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg('')} className="mb-3 w-full text-right">
                        {ErrorMsg}
                    </rsuite.Message>
                )}

                <Form
                    fluid
                    model={model}
                    formValue={formValue}
                    onChange={setFormValue}
                    onSubmit={() => handleSubmit(true)}
                    className="w-full text-right"
                >
                    <Form.Group controlId="username">
                        <Form.ControlLabel className="text-gray-600 text-[13px] mb-1.5">نام کاربری</Form.ControlLabel>
                        <InputGroup inside className="rounded-lg">
                            <InputGroup.Addon>
                                <FiUser size={16} color="#8a94a6" />
                            </InputGroup.Addon>
                            <Form.Control
                                name="username"
                                accepter={Input}
                                type="text"
                                autoComplete="username"
                                placeholder="نام کاربری خود را وارد کنید"
                            />
                        </InputGroup>
                    </Form.Group>
                    <Form.Group controlId="password">
                        <Form.ControlLabel className="text-gray-600 text-[13px] mb-1.5">رمز عبور</Form.ControlLabel>
                        <InputGroup inside className="rounded-lg">
                            <InputGroup.Addon>
                                <FiLock size={16} color="#8a94a6" />
                            </InputGroup.Addon>
                            <Form.Control
                                name="password"
                                type={showPassword ? 'text' : 'password'}
                                autoComplete="current-password"
                                accepter={Input}
                                placeholder="رمز عبور را وارد کنید"
                            />
                            <InputGroup.Addon
                                className="cursor-pointer"
                                onClick={() => setShowPassword((v) => !v)}
                            >
                                {showPassword ? (
                                    <FiEyeOff size={16} color="#8a94a6" />
                                ) : (
                                    <FiEye size={16} color="#8a94a6" />
                                )}
                            </InputGroup.Addon>
                        </InputGroup>
                    </Form.Group>

                    <Form.Group className="mt-2">
                        <Button
                            block
                            type="submit"
                            disabled={loading}
                            className="!bg-brand !border-brand !text-white h-11 text-[15px] font-semibold"
                        >
                            {loading ? <Loader content="لطفا صبر کنید..." /> : 'ورود'}
                        </Button>
                    </Form.Group>
                </Form>
            </div>
        </div>
    );
};

export default Login;
